function loadRecommendationCatalog() {
  if (typeof window !== 'undefined' && window.QuizRecommendationCatalog) {
    return window.QuizRecommendationCatalog;
  }

  if (typeof module !== 'undefined') {
    try {
      return require('./chestionar-recommendation-catalog.js').QUIZ_RECOMMENDATION_CATALOG;
    } catch (error) {
      console.warn('Quiz recommendation catalog unavailable:', error);
    }
  }

  return {
    previewHandles: [],
    roleOrder: ['primary', 'complementary', 'optional'],
    roleTargets: {
      primary: 2,
      complementary: 2,
      optional: 2
    },
    roleThresholdRatios: {
      primary: 0.42,
      complementary: 0.3,
      optional: 0.2
    },
    tierLabels: {},
    answerNeedMap: {},
    products: []
  };
}

const QUIZ_RECOMMENDATION_DATA = loadRecommendationCatalog();

const QUIZ_EVENTS_ENDPOINT = 'https://ivnvjxeoceggimwkntip.supabase.co/functions/v1/architect-events';

const QUIZ_QUESTIONS = [
  {
    id: 'q1',
    title: 'Ce vrei să meargă mai bine în viața ta activă?',
    description: 'Alege zona în care vrei să simți prima diferență clară.',
    options: [
      {
        id: 'energy_focus',
        label: 'Energie și focus constant',
        description: 'Pentru zile lungi, claritate și randament stabil.'
      },
      {
        id: 'recovery_sleep',
        label: 'Recuperare, somn și stres mai bine ținute sub control',
        description: 'Pentru seri mai liniștite și revenire mai bună.'
      },
      {
        id: 'metabolism_form',
        label: 'Metabolism, tonus și formă pe termen lung',
        description: 'Pentru echilibru, vitalitate și structură sustenabilă.'
      }
    ]
  },
  {
    id: 'q2',
    title: 'Cum arată ritmul tău zilnic?',
    description: 'Marchează sursa principală de solicitare din prezent.',
    options: [
      {
        id: 'mental_work',
        label: 'Muncă mentală intensă',
        description: 'Focus, decizii rapide și multe ore la birou.'
      },
      {
        id: 'stress_schedule',
        label: 'Program aglomerat și stres constant',
        description: 'Deadline-uri dese și puține momente reale de reset.'
      },
      {
        id: 'physical_effort',
        label: 'Multă mișcare, antrenamente sau efort fizic',
        description: 'Corp activ, consum ridicat și recuperare importantă.'
      }
    ]
  },
  {
    id: 'q3',
    title: 'Ce ai vrea să simți mai clar în următoarele săptămâni?',
    description: 'Selectează efectul pe care vrei să-l observi primul.',
    options: [
      {
        id: 'clarity_performance',
        label: 'Mai multă claritate și randament',
        description: 'Pentru minte mai limpede și energie mai stabilă.'
      },
      {
        id: 'balance_sleep',
        label: 'Mai mult echilibru și somn mai bun',
        description: 'Pentru un ritm mai calm și seri mai curate.'
      },
      {
        id: 'recovery_resilience',
        label: 'Recuperare și reziliență mai bune',
        description: 'Pentru revenire mai rapidă și toleranță mai bună la stres.'
      }
    ]
  },
  {
    id: 'q4',
    title: 'Cum e nivelul tău de activitate acum?',
    description: 'Răspunde după realitatea ultimei perioade, nu după intenții.',
    options: [
      {
        id: 'sport_regular',
        label: 'Sport regulat',
        description: 'Antrenamente consecvente și corp solicitat frecvent.'
      },
      {
        id: 'movement_occasional',
        label: 'Mișcare ocazională',
        description: 'Activitate prezentă, dar fără ritm sportiv constant.'
      },
      {
        id: 'low_movement',
        label: 'Puțină mișcare',
        description: 'Program sedentar sau perioadă cu activitate redusă.'
      }
    ]
  },
  {
    id: 'q5',
    title: 'Ce vrei să protejezi cel mai mult pe termen lung?',
    description: 'Asta ne ajută să alegem produsele complementare corecte.',
    options: [
      {
        id: 'brain_focus',
        label: 'Creierul, memoria și focusul',
        description: 'Pentru claritate mentală și performanță cognitivă susținută.'
      },
      {
        id: 'metabolism_heart',
        label: 'Metabolismul, inima și vitalitatea',
        description: 'Pentru echilibru metabolic și rezistență pe termen lung.'
      },
      {
        id: 'skin_joints',
        label: 'Articulațiile, pielea și țesuturile',
        description: 'Pentru structură, aspect și confort mai bun în timp.'
      }
    ]
  },
  {
    id: 'q6',
    title: 'Când simți cel mai clar că stilul tău de viață te taxează?',
    description: 'Alege momentul în care apare cel mai des fricțiunea.',
    options: [
      {
        id: 'hard_morning',
        label: 'Dimineața, pornesc greu',
        description: 'Start lent, energie mică și greu intri în ritm.'
      },
      {
        id: 'afternoon_crash',
        label: 'După-amiaza, mi se taie energia',
        description: 'Cădere de focus și randament înainte de finalul zilei.'
      },
      {
        id: 'heavy_evening',
        label: 'Seara, mă simt încărcat și mă recuperez greu',
        description: 'Simți acumulare, tensiune și revenire lentă.'
      }
    ]
  }
];

const QUESTION_WEIGHTS = {
  q1: 1.6,
  q2: 1,
  q3: 1.5,
  q4: 1,
  q5: 1.5,
  q6: 1
};

const ROLE_ORDER = QUIZ_RECOMMENDATION_DATA.roleOrder || ['primary', 'complementary', 'optional'];
const ROLE_TARGETS = QUIZ_RECOMMENDATION_DATA.roleTargets || {
  primary: 2,
  complementary: 2,
  optional: 2
};
const ROLE_THRESHOLD_RATIOS = QUIZ_RECOMMENDATION_DATA.roleThresholdRatios || {
  primary: 0.42,
  complementary: 0.3,
  optional: 0.2
};
const DEFAULT_PREVIEW_RECOMMENDATIONS = QUIZ_RECOMMENDATION_DATA.previewHandles || [];
const QUESTION_SELECTION_HOLD_MS = 420;

function normalizeConditionValues(value) {
  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value === 'undefined' || value === null) {
    return [];
  }

  return [value];
}

function createZeroNeedScores(catalog = QUIZ_RECOMMENDATION_DATA) {
  const scores = {};

  Object.values(catalog.answerNeedMap || {}).forEach((questionConfig) => {
    Object.values(questionConfig || {}).forEach((needMap) => {
      Object.keys(needMap || {}).forEach((needKey) => {
        scores[needKey] = 0;
      });
    });
  });

  return scores;
}

function matchesAnswerConditions(answers, conditions = {}) {
  return Object.entries(conditions).every(([questionId, expectedValues]) => {
    const allowedValues = normalizeConditionValues(expectedValues);
    return allowedValues.includes(answers[questionId]);
  });
}

function scoreNeedProfile(answers, catalog = QUIZ_RECOMMENDATION_DATA) {
  const needScores = createZeroNeedScores(catalog);

  Object.entries(answers).forEach(([questionId, optionId]) => {
    const weightedNeeds = catalog.answerNeedMap?.[questionId]?.[optionId];
    if (!weightedNeeds) {
      return;
    }

    const questionWeight = QUESTION_WEIGHTS[questionId] || 1;
    Object.entries(weightedNeeds).forEach(([needKey, score]) => {
      needScores[needKey] = (needScores[needKey] || 0) + (score * questionWeight);
    });
  });

  return needScores;
}

function scoreProductEntry(productEntry, needScores, answers) {
  if (productEntry.requires && !matchesAnswerConditions(answers, productEntry.requires)) {
    return Number.NEGATIVE_INFINITY;
  }

  let score = productEntry.bias || 0;

  Object.entries(productEntry.weights || {}).forEach(([needKey, weight]) => {
    score += (needScores[needKey] || 0) * weight;
  });

  (productEntry.boosts || []).forEach((boost) => {
    if (matchesAnswerConditions(answers, boost.when || {})) {
      score += boost.score || 0;
    }
  });

  return score;
}

function buildScoredProducts(answers, products, catalog = QUIZ_RECOMMENDATION_DATA) {
  const needScores = scoreNeedProfile(answers, catalog);
  const scoresByHandle = {};
  const scoredProducts = (catalog.products || [])
    .filter((productEntry) => products[productEntry.handle])
    .map((productEntry) => {
      const score = scoreProductEntry(productEntry, needScores, answers);
      scoresByHandle[productEntry.handle] = Number.isFinite(score) ? score : Number.NEGATIVE_INFINITY;

      return {
        ...productEntry,
        score
      };
    })
    .filter((productEntry) => Number.isFinite(productEntry.score))
    .sort((left, right) => {
      if (right.score !== left.score) {
        return right.score - left.score;
      }

      return left.handle.localeCompare(right.handle);
    });

  return {
    needScores,
    scoresByHandle,
    scoredProducts
  };
}

function productConflictsWithSelected(productEntry, selectedHandles, productMap) {
  const selectedSet = new Set(selectedHandles);
  const exclusiveWith = new Set(productEntry.exclusiveWith || []);

  if ([...exclusiveWith].some((handle) => selectedSet.has(handle))) {
    return true;
  }

  return selectedHandles.some((selectedHandle) => {
    const selectedProduct = productMap.get(selectedHandle);
    return Boolean(selectedProduct?.exclusiveWith?.includes(productEntry.handle));
  });
}

function getRoleThreshold(role, topScore) {
  const ratio = ROLE_THRESHOLD_RATIOS[role] || 0;
  const absoluteFloors = {
    primary: 6,
    complementary: 4.5,
    optional: 3.5
  };

  return Math.max((topScore || 0) * ratio, absoluteFloors[role] || 0);
}

function selectTierHandles(role, targetCount, scoredProducts, selectedHandles, productMap, topScore) {
  const threshold = getRoleThreshold(role, topScore);
  const pickedHandles = [];

  const tryPick = (candidateList) => {
    candidateList.forEach((productEntry) => {
      if (pickedHandles.length >= targetCount) {
        return;
      }

      if (selectedHandles.includes(productEntry.handle) || pickedHandles.includes(productEntry.handle)) {
        return;
      }

      if (!productEntry.roles?.includes(role)) {
        return;
      }

      if (productConflictsWithSelected(productEntry, [...selectedHandles, ...pickedHandles], productMap)) {
        return;
      }

      pickedHandles.push(productEntry.handle);
    });
  };

  tryPick(scoredProducts.filter((productEntry) => productEntry.score >= threshold));

  if (pickedHandles.length < targetCount) {
    tryPick(scoredProducts.filter((productEntry) => productEntry.score > 0));
  }

  return pickedHandles;
}

function createTierHandleGroups(handles, roleTargets = ROLE_TARGETS, roleOrder = ROLE_ORDER) {
  const groups = {};
  let cursor = 0;

  roleOrder.forEach((role) => {
    const count = roleTargets[role] || 0;
    groups[role] = handles.slice(cursor, cursor + count);
    cursor += count;
  });

  return groups;
}

function fillMissingHandles(orderedHandles, scoredProducts, productMap, products) {
  const targetCount = ROLE_ORDER.reduce((total, role) => total + (ROLE_TARGETS[role] || 0), 0);
  const filledHandles = [...orderedHandles];
  const fallbackHandles = [
    ...DEFAULT_PREVIEW_RECOMMENDATIONS,
    ...scoredProducts.map((productEntry) => productEntry.handle),
    ...Object.keys(products)
  ];

  fallbackHandles.forEach((handle) => {
    if (filledHandles.length >= targetCount || !products[handle] || filledHandles.includes(handle)) {
      return;
    }

    const productEntry = productMap.get(handle);
    if (productEntry && productConflictsWithSelected(productEntry, filledHandles, productMap)) {
      return;
    }

    filledHandles.push(handle);
  });

  return filledHandles.slice(0, targetCount);
}

function calculateRecommendations(answers, products, catalog = QUIZ_RECOMMENDATION_DATA) {
  const { needScores, scoresByHandle, scoredProducts } = buildScoredProducts(answers, products, catalog);
  const productMap = new Map(scoredProducts.map((productEntry) => [productEntry.handle, productEntry]));
  const topScore = scoredProducts[0]?.score || 0;
  const tierHandles = {};
  const selectedHandles = [];

  ROLE_ORDER.forEach((role) => {
    const handlesForRole = selectTierHandles(
      role,
      ROLE_TARGETS[role] || 0,
      scoredProducts,
      selectedHandles,
      productMap,
      topScore
    );
    tierHandles[role] = handlesForRole;
    selectedHandles.push(...handlesForRole);
  });

  const orderedHandles = fillMissingHandles(selectedHandles, scoredProducts, productMap, products);
  const orderedTierHandles = createTierHandleGroups(orderedHandles);

  return {
    handles: orderedHandles,
    tiers: orderedTierHandles,
    needScores,
    scores: scoresByHandle
  };
}

function findQuestionById(questionId) {
  return QUIZ_QUESTIONS.find((question) => question.id === questionId);
}

function findOption(questionId, optionId) {
  return findQuestionById(questionId)?.options.find((option) => option.id === optionId);
}

function buildLeadSummary(answers, handles, products) {
  const answerLines = QUIZ_QUESTIONS.map((question) => {
    const option = findOption(question.id, answers[question.id]);
    return option ? `${question.title}: ${option.label}` : null;
  }).filter(Boolean);

  const tierHandles = createTierHandleGroups(handles);
  const recommendationLines = ROLE_ORDER.flatMap((role) => {
    const tierLabel = QUIZ_RECOMMENDATION_DATA.tierLabels?.[role]?.title || role;
    const tierItems = (tierHandles[role] || [])
      .map((handle, index) => products[handle]?.title ? `${index + 1}. ${products[handle].title}` : null)
      .filter(Boolean);

    return tierItems.length ? [`${tierLabel}:`, ...tierItems, ''] : [];
  }).filter(Boolean);

  return [
    'Quiz recomandări produse',
    '',
    'Răspunsuri:',
    ...answerLines,
    '',
    'Produse recomandate:',
    ...recommendationLines
  ].join('\n');
}

function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function getCartSectionsToRender() {
  return [
    {
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }
  ];
}

function getSectionInnerHTML(html, selector) {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
  const node = parsedHTML.querySelector(selector) || parsedHTML.querySelector('.shopify-section');
  return node ? node.innerHTML : html;
}

function fireCustomEvent(name, detail) {
  if (typeof dispatchCustomEvent === 'function') {
    dispatchCustomEvent(name, detail);
    return;
  }
  document.dispatchEvent(new CustomEvent(name, { detail }));
}

function createQuizSessionId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const value = Math.random() * 16 | 0;
    return (character === 'x' ? value : (value & 3 | 8)).toString(16);
  });
}

async function insertQuizConversion(payload) {
  try {
    const response = await fetch(QUIZ_EVENTS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true
    });

    if (!response.ok) {
      console.warn('Quiz Supabase insert error:', await response.text());
      return false;
    }

    return true;
  } catch (error) {
    console.warn('Quiz Supabase fetch error:', error);
    return false;
  }
}

class ChestionarQuiz {
  constructor(container) {
    this.container = container;
    this.configNode = container.querySelector('[data-quiz-config]');
    this.config = this.parseConfig();
    this.products = this.config.products || {};
    this.labels = this.config.labels || {};
    this.answers = {};
    this.currentQuestionIndex = 0;
    this.recommendedHandles = [];
    this.recommendationTiers = createTierHandleGroups([]);
    this.currentPanel = 'question';
    this.storageKey = `chestionar-quiz-state:${container.id || 'default'}`;
    this.quizSessionId = createQuizSessionId();
    this.visitorId = this.getVisitorId();
    this.customerContext = this.parseCustomerContext();
    this.isQuestionTransitioning = false;
    this.isLeadSubmitting = false;
    this.hasTrackedResults = false;
    this.hasTrackedStart = false;
    this.emailSyncTimers = [];

    this.panels = {
      question: container.querySelector('[data-panel="question"]'),
      email_gate: container.querySelector('[data-panel="email_gate"]'),
      results: container.querySelector('[data-panel="results"]')
    };

    this.progressLabel = container.querySelector('[data-progress-label]');
    this.progressFill = container.querySelector('[data-progress-fill]');
    this.questionIndex = container.querySelector('[data-question-index]');
    this.questionTitle = container.querySelector('[data-question-title]');
    this.questionDescription = container.querySelector('[data-question-description]');
    this.optionsContainer = container.querySelector('[data-options]');
    this.answerChips = container.querySelector('[data-answer-chips]');
    this.resultsGrid = container.querySelector('[data-results-grid]');
    this.resultsFeedback = container.querySelector('[data-results-feedback]');
    this.form = container.querySelector('.quiz-lab__lead-form');
    this.feedback = container.querySelector('[data-form-feedback]');
    this.emailInput = container.querySelector('[data-lead-email]');
    this.bodyInput = container.querySelector('[data-lead-body]');
    this.submitButton = container.querySelector('[data-lead-submit]');

    this.debugLog('constructor ready', {
      hasOptionsContainer: Boolean(this.optionsContainer),
      hasProgressLabel: Boolean(this.progressLabel)
    });
    this.bindEvents();
    this.start();
    this.trackEvent('full_quiz_viewed');
  }

  getVisitorId() {
    try {
      const key = 'nmn-analytics:visitor-id:v1';
      const existing = window.localStorage.getItem(key);
      if (existing) return existing;
      const created = createQuizSessionId();
      window.localStorage.setItem(key, created);
      return created;
    } catch (error) { return createQuizSessionId(); }
  }

  parseCustomerContext() {
    try { return JSON.parse(this.container.querySelector('[data-lap-customer-context]')?.textContent || '{"logged_in":false}'); }
    catch (error) { return { logged_in: false }; }
  }

  productPayload(handle) {
    const product = this.products[handle] || {};
    return {
      id: handle,
      name: product.title || handle,
      handle,
      variant_id: product.variantId || null,
      format: null,
      price: Number(String(product.price || '').replace(/[^0-9,.-]/g, '').replace(',', '.')) || null
    };
  }

  trackEvent(eventName, overrides = {}) {
    insertQuizConversion(this.buildQuizTrackingPayload({ event_name: eventName, ...overrides }));
  }

  debugLog(message, details = null) {
    if (typeof window === 'undefined') {
      return;
    }

    if (typeof window.__QUIZ_DEBUG_LOG === 'function') {
      window.__QUIZ_DEBUG_LOG(message, details);
    }
  }

  parseConfig() {
    if (!this.configNode) {
      return { products: {}, labels: {} };
    }

    try {
      return JSON.parse(this.configNode.textContent.trim());
    } catch (error) {
      console.warn('Quiz config parse failed, using fallback config.', error);
      return {
        products: {},
        labels: {}
      };
    }
  }

  bindEvents() {
    const optionInteractionHandler = (event) => {
      const optionButton = event.target?.closest?.('[data-option-id]');
      if (!optionButton || !this.optionsContainer?.contains(optionButton)) {
        return;
      }

      if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) {
        return;
      }

      event.preventDefault?.();
      this.handleOptionSelection(optionButton);
    };

    this.optionsContainer?.addEventListener('click', optionInteractionHandler, true);
    this.optionsContainer?.addEventListener('keydown', optionInteractionHandler, true);

    this.container.addEventListener('click', (event) => {
      const resetButton = event.target.closest('[data-reset-quiz]');
      if (resetButton) {
        this.resetQuiz();
        return;
      }

      const addToCartButton = event.target.closest('[data-quiz-add-to-cart]');
      if (addToCartButton) {
        event.preventDefault();
        this.addToCart(addToCartButton);
      }
    });

    this.submitButton?.addEventListener('click', (event) => this.handleLeadSubmit(event));
    this.form?.addEventListener('submit', (event) => this.handleLeadSubmit(event));
    this.emailInput?.addEventListener('input', () => this.queueEmailStateSync());
    this.emailInput?.addEventListener('change', () => this.queueEmailStateSync());
    this.emailInput?.addEventListener('focus', () => this.queueEmailStateSync());
    this.emailInput?.addEventListener('blur', () => this.queueEmailStateSync());
  }

  bindOptionButtons() {
    this.optionsContainer?.querySelectorAll('[data-option-id]').forEach((button) => {
      if (button.dataset.quizOptionBound === 'true') {
        return;
      }

      button.dataset.quizOptionBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.handleOptionSelection(button);
      });
      button.addEventListener('keydown', (event) => {
        if (!['Enter', ' '].includes(event.key)) {
          return;
        }

        event.preventDefault();
        this.handleOptionSelection(button);
      });
    });
  }

  start() {
    this.debugLog('start', {
      initialState: this.config.initialState || 'question'
    });
    if (this.restoreState()) {
      this.debugLog('restoreState returned true', {
        currentQuestionIndex: this.currentQuestionIndex,
        currentPanel: this.currentPanel
      });
      return;
    }

    const initialState = this.config.initialState || 'question';
    if (initialState === 'email_gate') {
      this.recommendedHandles = this.getPreviewRecommendations();
      this.recommendationTiers = createTierHandleGroups(this.recommendedHandles);
      this.syncLeadBody();
      this.renderAnswerChips(true);
      this.showPanel('email_gate');
      return;
    }

    if (initialState === 'results') {
      this.recommendedHandles = this.getPreviewRecommendations();
      this.recommendationTiers = createTierHandleGroups(this.recommendedHandles);
      this.renderResults();
      this.showPanel('results');
      return;
    }

    this.renderQuestion();
    this.showPanel('question');
  }

  getPreviewRecommendations() {
    const targetCount = ROLE_ORDER.reduce((total, role) => total + (ROLE_TARGETS[role] || 0), 0);
    const previewHandles = this.config.previewRecommendations?.length ? this.config.previewRecommendations : DEFAULT_PREVIEW_RECOMMENDATIONS;
    const orderedHandles = [
      ...previewHandles.filter((handle) => this.products[handle]),
      ...Object.keys(this.products)
    ];

    return [...new Set(orderedHandles)].slice(0, targetCount);
  }

  showPanel(panelKey) {
    this.debugLog('showPanel', { panelKey });
    this.currentPanel = panelKey;
    Object.entries(this.panels).forEach(([key, panel]) => {
      if (!panel) {
        return;
      }
      panel.hidden = key !== panelKey;
    });
    this.persistState(panelKey);
  }

  renderQuestion() {
    const question = QUIZ_QUESTIONS[this.currentQuestionIndex];
    if (!question || !this.optionsContainer) {
      this.debugLog('renderQuestion aborted', {
        hasQuestion: Boolean(question),
        hasOptionsContainer: Boolean(this.optionsContainer)
      });
      return;
    }

    const questionNumber = this.currentQuestionIndex + 1;
    if (this.progressLabel) {
      this.progressLabel.textContent = `Pasul ${questionNumber} din ${QUIZ_QUESTIONS.length}`;
    }
    if (this.progressFill) {
      this.progressFill.style.width = `${(questionNumber / QUIZ_QUESTIONS.length) * 100}%`;
    }
    if (this.questionIndex) {
      this.questionIndex.textContent = String(questionNumber).padStart(2, '0');
    }
    if (this.questionTitle) {
      this.questionTitle.textContent = question.title;
    }
    if (this.questionDescription) {
      this.questionDescription.textContent = question.description || this.labels.questionHint || '';
    }
    this.isQuestionTransitioning = false;

    this.optionsContainer.innerHTML = question.options.map((option) => `
      <button class="quiz-lab__option" type="button" data-option-id="${option.id}">
        <span class="quiz-lab__option-indicator" aria-hidden="true"></span>
        <span class="quiz-lab__option-label">${option.label}</span>
      </button>
    `).join('');

    this.bindOptionButtons();
    this.debugLog('renderQuestion complete', {
      questionId: question.id,
      questionNumber,
      optionCount: question.options.length
    });
  }

  advanceAfterSelection() {
    this.debugLog('advanceAfterSelection', {
      currentQuestionIndex: this.currentQuestionIndex
    });

    if (this.currentQuestionIndex < QUIZ_QUESTIONS.length - 1) {
      this.currentQuestionIndex += 1;
      this.renderQuestion();
      this.persistState('question');
      this.debugLog('advanced to next question', {
        currentQuestionIndex: this.currentQuestionIndex
      });
      return;
    }

    this.prepareRecommendations();
    this.renderAnswerChips();
    this.showPanel('email_gate');
    this.isQuestionTransitioning = false;
    this.debugLog('advanced to email gate');
  }

  scheduleAdvanceAfterSelection() {
    const proceed = () => {
      try {
        this.advanceAfterSelection();
      } catch (error) {
        this.isQuestionTransitioning = false;
        this.debugLog('advance error', {
          message: error?.message || String(error)
        });
        throw error;
      }
    };

    window.setTimeout(proceed, QUESTION_SELECTION_HOLD_MS);
  }

  handleOptionSelection(optionButton) {
    this.debugLog('handleOptionSelection called', {
      currentQuestionIndex: this.currentQuestionIndex,
      optionId: optionButton?.dataset?.optionId,
      isQuestionTransitioning: this.isQuestionTransitioning
    });

    if (this.isQuestionTransitioning) {
      return;
    }

    const question = QUIZ_QUESTIONS[this.currentQuestionIndex];
    if (!question) {
      return;
    }

    const optionId = optionButton?.dataset.optionId;
    if (!optionId) {
      return;
    }

    this.answers[question.id] = optionId;
    if (!this.hasTrackedStart) {
      this.hasTrackedStart = true;
      this.trackEvent('full_quiz_started');
    }
    this.trackEvent('full_quiz_answered', { quiz_answers: [{ question_id: question.id, answer_id: optionId }] });
    this.isQuestionTransitioning = true;

    this.optionsContainer?.querySelectorAll('[data-option-id]').forEach((button) => {
      button.disabled = true;
      button.classList.toggle('is-selected', button === optionButton);
    });
    this.persistState('question');
    this.debugLog('selection persisted', {
      answerQuestionId: question.id,
      answerOptionId: optionId
    });
    this.scheduleAdvanceAfterSelection();
  }

  prepareRecommendations() {
    const recommendationData = calculateRecommendations(this.answers, this.products);
    this.recommendedHandles = recommendationData.handles;
    this.recommendationTiers = recommendationData.tiers;
    this.syncLeadBody();
  }

  renderAnswerChips(isPreview = false) {
    if (!this.answerChips) {
      return;
    }

    const chipQuestionIds = isPreview ? ['q1', 'q3', 'q5'] : ['q1', 'q3', 'q5'];
    const chips = chipQuestionIds.map((questionId) => {
      const optionId = this.answers[questionId];
      const option = optionId ? findOption(questionId, optionId) : null;
      return option ? `<span>${option.label}</span>` : null;
    }).filter(Boolean);

    this.answerChips.innerHTML = chips.join('');
  }

  syncLeadBody() {
    if (!this.bodyInput) {
      return;
    }
    this.bodyInput.value = buildLeadSummary(this.answers, this.recommendedHandles, this.products);
  }

  getStoredState() {
    if (typeof window === 'undefined' || !window.sessionStorage) {
      return null;
    }

    try {
      const rawState = window.sessionStorage.getItem(this.storageKey);
      return rawState ? JSON.parse(rawState) : null;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  persistState(panelKey = this.currentPanel) {
    if (typeof window === 'undefined' || !window.sessionStorage) {
      return;
    }

    try {
      window.sessionStorage.setItem(this.storageKey, JSON.stringify({
        panel: panelKey,
        answers: this.answers,
        currentQuestionIndex: this.currentQuestionIndex,
        recommendedHandles: this.recommendedHandles,
        email: this.emailInput?.value.trim() || '',
        quizSessionId: this.quizSessionId,
        hasTrackedResults: this.hasTrackedResults
      }));
    } catch (error) {
      console.error(error);
    }
  }

  clearStoredState() {
    if (typeof window === 'undefined' || !window.sessionStorage) {
      return;
    }

    try {
      window.sessionStorage.removeItem(this.storageKey);
    } catch (error) {
      console.error(error);
    }
  }

  queueEmailStateSync() {
    if (typeof window === 'undefined') {
      return;
    }

    this.emailSyncTimers.forEach((timerId) => window.clearTimeout(timerId));
    this.emailSyncTimers = [0, 80, 220].map((delay) => window.setTimeout(() => {
      this.persistState();
    }, delay));
  }

  restoreState() {
    const storedState = this.getStoredState();
    if (!storedState || typeof storedState !== 'object') {
      return false;
    }

    const targetCount = ROLE_ORDER.reduce((total, role) => total + (ROLE_TARGETS[role] || 0), 0);

    this.answers = storedState.answers && typeof storedState.answers === 'object' ? storedState.answers : {};
    this.currentQuestionIndex = Number.isInteger(storedState.currentQuestionIndex)
      ? Math.max(0, Math.min(storedState.currentQuestionIndex, QUIZ_QUESTIONS.length - 1))
      : 0;
    this.recommendedHandles = Array.isArray(storedState.recommendedHandles)
      ? storedState.recommendedHandles.filter((handle) => this.products[handle]).slice(0, targetCount)
      : [];
    this.recommendationTiers = createTierHandleGroups(this.recommendedHandles);
    if (/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(storedState.quizSessionId || '')) this.quizSessionId = storedState.quizSessionId;
    this.hasTrackedResults = Boolean(storedState.hasTrackedResults);

    if (this.emailInput && storedState.email) {
      this.emailInput.value = storedState.email;
    }

    if (storedState.panel === 'results' && this.recommendedHandles.length) {
      this.renderAnswerChips();
      this.syncLeadBody();
      this.renderResults();
      this.showPanel('results');
      return true;
    }

    if (storedState.panel === 'email_gate' && this.recommendedHandles.length) {
      this.renderAnswerChips();
      this.syncLeadBody();
      this.showPanel('email_gate');
      return true;
    }

    this.renderQuestion();
    this.showPanel('question');
    return true;
  }

  buildQuizTrackingPayload(overrides = {}) {
    const landing = new URL(window.location.href);
    let referrerHost = '';
    try { referrerHost = document.referrer ? new URL(document.referrer).hostname : ''; } catch (error) { referrerHost = ''; }
    const answers = Object.entries(this.answers).map(([questionId, answerId]) => ({ question_id: questionId, answer_id: answerId }));
    return {
      event_id: createQuizSessionId(),
      occurred_at: new Date().toISOString(),
      session_id: this.quizSessionId,
      visitor_id: this.visitorId,
      event_name: 'full_quiz_results_viewed',
      source_page: 'full_quiz',
      page_path: window.location.pathname,
      page_title: document.title,
      session: {
        landing_path: `${landing.pathname}${landing.search}`.slice(0, 300),
        referrer_host: referrerHost,
        utm_source: landing.searchParams.get('utm_source'),
        utm_medium: landing.searchParams.get('utm_medium'),
        utm_campaign: landing.searchParams.get('utm_campaign'),
        utm_content: landing.searchParams.get('utm_content'),
        utm_term: landing.searchParams.get('utm_term'),
        device_type: window.innerWidth <= 768 ? 'mobile' : 'desktop',
        locale: document.documentElement.lang || navigator.language,
        country_code: window.Shopify?.country || null,
        currency_code: window.Shopify?.currency?.active || null
      },
      customer: { ...this.customerContext, email: this.emailInput?.value.trim() || this.customerContext.email || null },
      directions: [],
      quiz_answers: answers,
      recommended_products: this.recommendedHandles.map((handle) => this.productPayload(handle)),
      selected_products: [],
      recommendation_set: this.recommendedHandles.join('|').slice(0, 120),
      currency_code: window.Shopify?.currency?.active || null,
      ...overrides
    };
  }

  async trackResultsViewed() {
    if (this.hasTrackedResults) {
      return;
    }

    const emailValue = this.emailInput?.value.trim();
    if (!emailValue) {
      return;
    }

    this.hasTrackedResults = true;
    this.persistState('results');
    await insertQuizConversion(this.buildQuizTrackingPayload({ event_name: 'full_quiz_results_viewed' }));
  }

  async handleLeadSubmit(event) {
    event?.preventDefault?.();

    if (this.isLeadSubmitting) {
      return;
    }

    const emailValue = this.emailInput?.value.trim();
    const emailValid = Boolean(emailValue) && /.+@.+\..+/.test(emailValue);

    if (!emailValid) {
      this.setFeedback(this.labels.emailError || 'Completează datele cerute pentru a continua.');
      return;
    }

    this.syncLeadBody();
    this.setFeedback('');
    this.renderResults();
    this.showPanel('results');
    this.trackResultsViewed();
    this.isLeadSubmitting = true;

    if (this.submitButton) {
      this.submitButton.disabled = true;
      this.submitButton.textContent = this.submitButton.getAttribute('data-loading-label') || this.submitButton.textContent;
    }

    try {
      const response = await fetch(this.form.action, {
        method: this.form.method || 'POST',
        body: new FormData(this.form),
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error('Lead submit failed');
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.isLeadSubmitting = false;
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.textContent = this.form?.querySelector('[data-lead-submit]')?.getAttribute('data-original-label') || 'Vezi recomandările';
      }
    }
  }

  setFeedback(message, isSuccess = false) {
    if (!this.feedback) {
      return;
    }
    this.feedback.textContent = message;
    this.feedback.classList.toggle('is-success', isSuccess);
  }

  setResultsFeedback(message) {
    if (!this.resultsFeedback) {
      return;
    }
    this.resultsFeedback.textContent = message;
  }

  renderProductCard(product) {
    const catalogProduct = QUIZ_RECOMMENDATION_DATA.products?.find((entry) => entry.handle === product.handle);
    const benefit = catalogProduct?.benefit || '';
    const isQuickAdd = Boolean(product.available) && Boolean(product.variantId);
    const safeUrl = product.url || '#';
    const safeTitle = escapeHtml(product.title);
    const safeImageAlt = escapeHtml(product.imageAlt || product.title);
    const safeBenefit = escapeHtml(benefit);
    const safePrice = escapeHtml(product.price);

    return `
      <article class="quiz-lab__result-card">
        <a class="quiz-lab__result-media" href="${safeUrl}">
          ${product.image ? `<img src="${product.image}" alt="${safeImageAlt}" loading="lazy">` : ''}
        </a>
        <div class="quiz-lab__result-body">
          <h4 class="quiz-lab__result-title"><a href="${safeUrl}">${safeTitle}</a></h4>
          <p class="quiz-lab__result-benefit">${safeBenefit}</p>
        </div>
        <div class="quiz-lab__result-footer">
          <span class="quiz-lab__result-price">${safePrice}</span>
          ${isQuickAdd
            ? `<button class="quiz-lab__result-action" type="button" data-quiz-add-to-cart data-variant-id="${product.variantId}" data-product-handle="${product.handle}">${this.labels.addToCart || 'Adaugă în coș'}</button>`
            : `<a class="quiz-lab__result-link" href="${safeUrl}">${this.labels.viewProduct || 'Vezi produsul'}</a>`}
        </div>
      </article>
    `;
  }

  renderResults() {
    if (!this.resultsGrid) {
      return;
    }

    const handles = this.recommendedHandles.length ? this.recommendedHandles : this.getPreviewRecommendations();
    const tierHandles = this.recommendedHandles.length ? this.recommendationTiers : createTierHandleGroups(handles);
    this.setResultsFeedback('');

    const tierMarkup = ROLE_ORDER.map((role) => {
      const handlesForRole = tierHandles[role] || [];
      const productsForRole = handlesForRole.map((handle) => this.products[handle]).filter(Boolean);

      if (!productsForRole.length) {
        return '';
      }

      const tierLabel = QUIZ_RECOMMENDATION_DATA.tierLabels?.[role] || {};

      return `
        <section class="quiz-lab__results-tier quiz-lab__results-tier--${role}">
          <div class="quiz-lab__tier-head">
            <span class="quiz-lab__tier-kicker">${tierLabel.title || role}</span>
            <p class="quiz-lab__tier-text">${tierLabel.description || ''}</p>
          </div>
          <div class="quiz-lab__tier-products">
            ${productsForRole.map((product) => this.renderProductCard(product)).join('')}
          </div>
        </section>
      `;
    }).join('');

    this.resultsGrid.innerHTML = tierMarkup || '<p class="quiz-lab__results-empty">Nu am putut compune recomandările acum. Reîncearcă în câteva secunde.</p>';
  }

  async addToCart(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) {
      return;
    }
    const productHandle = button.dataset.productHandle || null;

    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = this.labels.adding || 'Se adaugă...';

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('properties[_architect_source]', 'longevity-architect');
    formData.append('properties[_architect_session_id]', this.quizSessionId);
    formData.append('properties[_architect_visitor_id]', this.visitorId);
    formData.append('properties[_architect_recommendation_set]', this.recommendedHandles.join('|').slice(0, 120));
    formData.append('properties[_architect_product_id]', productHandle || '');
    formData.append('properties[_architect_product_handle]', productHandle || '');
    formData.append('sections', getCartSectionsToRender().map((section) => section.section));
    formData.append('sections_url', window.location.pathname);

    try {
      const response = await fetch(window.theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        },
        body: formData
      });
      const parsedState = await response.json();

      if (parsedState.status) {
        throw new Error(parsedState.description || 'Cart add failed');
      }

      if (parsedState.sections) {
        getCartSectionsToRender().forEach((section) => {
          const container = document.getElementById(section.id);
          if (!container) {
            return;
          }
          const elementToReplace = container.querySelector(section.selector) || container;
          elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });
      }

      if (typeof CartDrawer !== 'undefined') {
        new CartDrawer();
      }
      if (typeof Cart !== 'undefined') {
        new Cart().renderContents(parsedState);
      }
      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        fireCustomEvent('cart-drawer:open', {});
      }

      fireCustomEvent('cart:item-added', {
        product: parsedState.hasOwnProperty('items') ? parsedState.items[0] : parsedState
      });

      insertQuizConversion(this.buildQuizTrackingPayload({
        event_name: 'full_quiz_add_to_cart',
        product_id: productHandle,
        product_handle: productHandle,
        variant_id: String(variantId),
        selected_products: [this.productPayload(productHandle)]
      }));

      button.textContent = this.labels.added || 'Adăugat';
    } catch (error) {
      console.error(error);
      this.setResultsFeedback(this.labels.cartError || 'Nu am reușit să adăugăm produsul în coș.');
      button.textContent = originalLabel;
    } finally {
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = originalLabel;
      }, 1400);
    }
  }

  resetQuiz() {
    this.answers = {};
    this.currentQuestionIndex = 0;
    this.recommendedHandles = [];
    this.recommendationTiers = createTierHandleGroups([]);
    this.currentPanel = 'question';
    this.quizSessionId = createQuizSessionId();
    this.isQuestionTransitioning = false;
    this.isLeadSubmitting = false;
    this.hasTrackedResults = false;
    this.hasTrackedStart = false;
    this.emailSyncTimers.forEach((timerId) => window.clearTimeout(timerId));
    this.emailSyncTimers = [];
    this.form?.reset();
    this.clearStoredState();
    this.setFeedback('');
    this.setResultsFeedback('');
    this.renderQuestion();
    this.showPanel('question');
  }
}

if (typeof module !== 'undefined') {
  module.exports = {
    QUIZ_RECOMMENDATION_CATALOG: QUIZ_RECOMMENDATION_DATA,
    QUIZ_QUESTIONS,
    QUESTION_WEIGHTS,
    calculateRecommendations,
    scoreNeedProfile,
    scoreProductEntry
  };
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  const initializedQuizzes = new WeakSet();

  const initQuizzes = (root) => {
    const context = root || document;
    context.querySelectorAll('[data-chestionar-quiz]').forEach((quizNode) => {
      if (initializedQuizzes.has(quizNode)) {
        return;
      }
      initializedQuizzes.add(quizNode);

      const submitButton = quizNode.querySelector('[data-lead-submit]');
      if (submitButton && !submitButton.hasAttribute('data-original-label')) {
        submitButton.setAttribute('data-original-label', submitButton.textContent.trim());
        submitButton.setAttribute('data-loading-label', 'Se trimite...');
      }

      new ChestionarQuiz(quizNode);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initQuizzes(document));
  } else {
    initQuizzes(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initQuizzes(event.target);
  });
}
